// Overview: This file contains 4 slide decks associated with Software Engineering (SE) module 1 / sprint 1. Each 
// slidedeck is exported via the se_1_slidedeckTTR structure.

import { checklistAnnouncementsPreworkAndAgenda, completeDeck, tLab } from './SL00000Sprint00'
import { basicSlide, breakoutStandard, bulletListSlide, orderedListSlide, tPrework, tRecap } from './SLSprint00'
import { tQuizExpectations, tQuiz } from './SLSprint00'

import { list44000Sprint01 } from '../ActivityLists/AL44000Sprint01'
import { se_2_1of4_PAaA } from './SL44000Sprint02TTR'

import { holiday } from './SL20000Sprint01'
import { renderCalendar, renderFinalExamTimes } from './images/render-image'
import { tDiscussionBreakout } from './SLSprint00'

// Software Engineering (SE) module 1 / sprint 1 global values
const sprint = 1
const activityList = () => { return list44000Sprint01(sprint) }

// Shared slides across multiple sessions.
const sprintPlanning = () => {
	return orderedListSlide('Sprint Planning', `Sprint ${sprint} Expectations:`, [
		'Similar to future sprints with Discussion, Quiz, Lab, and Reflection',
		'As usual we will have two weeks to complete all sprint 1 assignments',
		'We will have a small celebration (puppy day?) if all assignments are submitted on time',
		'We will work on Discussion Board 1 as a scrum team in class on Thursday' ])
}
const activitiesReview = () => {
		return basicSlide('Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the activity list, syllabus, and assignments together.' ]
	)
}
const planningBreakout = () => {
	return orderedListSlide('Sprint Planning Scrum Team Breakout', 'As a scrum team:', [
		`Review sprint ${sprint} activity list & assignments in detail`,
		'Discuss and identify questions/concerns',
		'Scrum master report out by sharing scrum team’s top 2 or 3 questions/concerns',
		'How will you get your Scrum Team Discord server set up before class on Thursday?' ])
}
export const xyz_1_1of4 = (sprint, activityList, PAaA, PAaANext) => {
	const poll = () => { return tPrework('Sprint Progress Polling', PAaA.prework, sprint, activityList) }
	const switchDeck = () => { return bulletListSlide('Introductions Slides', 'Class Formant and Introductions slides.', [])}
	const preworkNext = () => { return tPrework('Prework For Next Class', PAaANext, sprint, activityList) }
	const recap = () => { return tRecap(se_1_1of4_PAaA.agenda) }

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(se_1_1of4_PAaA, sprint, activityList)
	return completeDeck(slideDeck, [poll, switchDeck, sprintPlanning, activitiesReview, planningBreakout, recap, preworkNext, renderCalendar, renderFinalExamTimes, holiday])
}

export const xyz_1_2of4 = (sprint, activityList, PAaA, PAaANext) => { 
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(PAaA, sprint, activityList)
	const poll = () => { return tPrework('Sprint Progress Polling', PAaA.prework, sprint, activityList) }
	const preworkNext = () => { return tPrework('Prework For Next Class', PAaANext, sprint, activityList) }
	const discussionBreakout = () => { return tDiscussionBreakout(sprint) }
	const lab = () => {
		return bulletListSlide('Lab', 
			'Let’s focus on completing our activities and assignments by:', [
			'Deciding how we can best utilize our time today', 
			'Completing the most important activities and assignments together',
			'Finalize Discord server setup?',
			'Start programming assignment?' ])
	}

	const recap = () => { return tRecap(PAaA.agenda.slice(1))}
	return completeDeck(slideDeck, [ poll, sprintPlanning, activitiesReview, planningBreakout, discussionBreakout, lab, recap, preworkNext ])
}

export const xyz_1_3of4 = (sprint, activityList, PAaA, PAaANext, breakoutSlide) => { 
	const poll = () => { return tPrework('Sprint Progress Polling', PAaA.prework, sprint, activityList) }
	const preworkNext = () => { return tPrework('Prework For Next Class', PAaANext, sprint, activityList) }
	const quizExpectations = () => { return tQuizExpectations() }
	const quiz = () => { return tQuiz(sprint) }
	const recap = () => { return tRecap(PAaA.agenda.slice(1))}
	const slideDeck =  checklistAnnouncementsPreworkAndAgenda(PAaA, sprint, activityList)
	return completeDeck(slideDeck, [ poll, breakoutSlide, preworkNext, recap, quizExpectations, quiz ])
}

// Todo: These two functions have been copy/pasted into SL0000Sprint00TTR.js. The local functions should be removed. 
export const  xyz_n_4of4_PAaA = (completeThrough, sprint) => {
	const preworkAnnouncementsAndAgenda = {
		'prework': [
			`${completeThrough}`, '',
			'Be prepared for Lab'],
		'announcements':[
			`All sprint ${sprint} assignments are due Sunday!`, 
			`In-person attendance is required next Tuesday for Sprint ${sprint+1} Planning`],
		'agenda':[
			`Final sprint ${sprint} activity list and assignment Q&A`,
			'Prework for Next Class', 
			'Lab']
	}
	return preworkAnnouncementsAndAgenda
}

export const xyz_n_4of4 = (sprint, activityList, PAaA, preworkListNext, discussion = null ) => {
	const finalReviewActivityListAndAssignments = () => { return basicSlide(
		`Final sprint ${sprint} activity list and assignment Q&A`, [`Any sprint ${sprint} activity list or assignment questions?`]) }
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', preworkListNext, sprint, activityList) }
	const recap = () => { return tRecap(PAaA.agenda)}

	if (discussion === null) {
		return completeDeck(slideDeck, [ finalReviewActivityListAndAssignments, preworkNext, tLab, recap ])
	}

	return completeDeck(slideDeck, [ finalReviewActivityListAndAssignments, preworkNext, discussion, tLab, recap ])
}
// End shared slides across multiple sessions.

// Session 1 of 4: Tuesday
export const se_1_1of4_PAaA = {
	'prework':[
		'Review Welcome Message',
		'Review Blended Learning & Flipped Classroom',
		'Review Introduction to Scrum',
		'Review Course Syllabus' ],
	'announcements':[ 
		'Welcome!', '',
		'Today’s Goal: Be prepared to utilize your team’s Discord server for our next class' ],
	'agenda':[
		'Progress Poll',
		'Class Format',
		'Introductions - Part 1',
		'Introductions - Part 2 and Scrum Team Assignments',
		'Sprint 1 Planning',
		'Sprint 1 Planning Scrum Team Breakout',
		'Prework for Next Class' ]
}
const se_1_1of4 = () => { return xyz_1_1of4(sprint, activityList, se_1_1of4_PAaA, se_1_2of4_PAaA.prework) }

// Session 2 of 4: Thursday
export const se_1_2of4_PAaA = {
	'prework':[
		'Complete through activity 7 prior to next class', '',
		'Be prepared to complete Discussion 1 as a scrum team',
		'Be prepared to utilize your team’s Discord server' ],
	'announcements':[ 
		'If you are planning to graduate after this semester, you must submit your application to graduate soon' ],
	'agenda':[
		'Introductions and Team Assignments (continued)',
		'Sprint 1 Planning (continued)',
		'Sprint 1 Planning Scrum Team Breakout',
		'Discussion Board 1 as a Scrum Team',
		'Lab',
		'Prework for Next Class' ]
}
const se_1_2of4 = () => { return xyz_1_2of4(sprint, activityList, se_1_2of4_PAaA, se_1_3of4_PAaA.prework) }

// Session 3 of 4: Tuesday
const breakoutSDLCsName = 'SDLCs and the Virtuous Triangle'
const breakoutSDLCs = () => { 
	return breakoutStandard(
		`Breakout: ${breakoutSDLCsName}`, 
		'In this breakout session your team will discuss', [
		'The Virtuous Triangle... Could Saas on Cloud Computing and Frameworks and Tools be combined?',
		'Software Development Life Cycles (SDLCs): Plan and Document, Iterative, and Agile',
		'SDLCs: Waterfall, Spiral, RUP',
		'Agile Manifesto',
		'SDLCs: Agile, Scrum, and Scaled Agile Framework (SAFe)',
		'Agile methodologies including Kanban, XP (formerly Extreme Programming), and Test-Driven Development' ])
}

export const se_1_3of4_PAaA = {
	'prework':[
		'Make your initial Discussion 1 post',
		'Complete through activity 10 prior to next class', 
		'Focus on reading Engineering Software as a Service Chapter 1 and the associated lecture',
		'... Chapter 1 and the associated lecture are a BIG deal!',
		`Be prepared for “${breakoutSDLCsName}” breakout`,
		'Be prepared for Quiz 1' ],
	'announcements':[
		'Your initial Discussion 1 post was due two days ago',
		'All sprint 1 activities and assignments due Sunday!',
		`In-person attendance is required next Tuesday for Sprint ${sprint+1} Planning` ],
	'agenda':[
		'Sprint Progress Polling',
		`Breakout: ${breakoutSDLCsName}`,
		'Prework for Next Class',	
		'Quiz 1' ]
}
const se_1_3of4 = () => { return xyz_1_3of4(sprint, activityList, se_1_3of4_PAaA, se_1_4of4_PAaA.prework, breakoutSDLCs) }

const se_1_4of4_PAaA = xyz_n_4of4_PAaA('Complete through activity 14', sprint)
const se_1_4of4 = () => { return  xyz_n_4of4(sprint, activityList, se_1_4of4_PAaA, se_2_1of4_PAaA.prework, breakoutSDLCs ) }

export const se_1_slidedeckTTR = [ se_1_1of4, se_1_2of4, se_1_3of4, se_1_4of4 ] 